export function getWidthsSum(
  breadcrumbItemWidths: number[],
  truncatedItemsCount: number,
  truncatedBreadcrumbItemSize: number
): number {
  const nonTruncatedWidth = breadcrumbItemWidths
    .slice(truncatedItemsCount)
    .reduce((sum, width) => sum + width, 0);

  return nonTruncatedWidth + truncatedItemsCount * truncatedBreadcrumbItemSize;
}

export function resolveTruncationCount(
  currentCount: number,
  parentWidth: number,
  previousParentWidth: number,
  breadcrumbItemWidths: number[],
  truncatedItemSize: number,
  totalItems: number
): number {
  const currentDifference = parentWidth - getWidthsSum(breadcrumbItemWidths, currentCount, truncatedItemSize);
  const widthSumWhenTruncatingOneLess = getWidthsSum(breadcrumbItemWidths, currentCount - 1, truncatedItemSize);

  let newCount = currentCount;

  if (parentWidth > previousParentWidth && parentWidth > widthSumWhenTruncatingOneLess + 20 && currentCount > 0) {
    newCount -= 1;
  }

  if (currentDifference < 20 && newCount < totalItems) {
    newCount += 1;
  }

  return newCount;
}
